import i18n from '@/lang';
/* unplugin-vue-components disabled */
import __unplugin_components_0 from 'G:/SVN/单小二/源代码/客户端门户/front/smy-toc-vux-cli3/src/components/SmyFullPopup.vue';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(__unplugin_components_0, {
    attrs: {
      "popupStyle": {
        zIndex: 150,
        background: '#fff'
      }
    },
    model: {
      value: _vm.isShow,
      callback: function ($$v) {
        _vm.isShow = $$v;
      },
      expression: "isShow"
    }
  }, [_c('view-box', {
    ref: "viewBox"
  }, [_c('Search', {
    ref: "search",
    attrs: {
      "placeholder": i18n.tc("695"),
      "auto-fixed": false,
      "auto-scroll-to-top": false,
      "top": "3.5rem"
    },
    on: {
      "on-submit": _vm.seachAddress,
      "on-cancel": function ($event) {
        _vm.position = '';
      }
    },
    model: {
      value: _vm.position,
      callback: function ($$v) {
        _vm.position = $$v;
      },
      expression: "position"
    }
  }), _c('div', {
    attrs: {
      "id": "mymap"
    }
  }), _c('div', {
    staticClass: "address"
  }, [_c('div', {
    staticClass: "address-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.nowAddress,
      expression: "nowAddress"
    }],
    staticClass: "item",
    on: {
      "click": function ($event) {
        return _vm.callback(_vm.center, _vm.nowAddress);
      }
    }
  }, [_c('p', {
    staticClass: "item-name"
  }), _c('p', {
    staticClass: "item-address"
  }, [_vm._v("[" + _vm._s(_vm.nowAddress) + "]")])]), _vm._l(_vm.searchResult, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      on: {
        "click": function ($event) {
          return _vm.callback([item.location.lng, item.location.lat], item.address, item.name);
        }
      }
    }, [_c('p', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(item.name))]), _c('p', {
      staticClass: "item-address"
    }, [_vm._v(_vm._s(item.address))])]);
  })], 2)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };